import Vue from 'vue'

Vue.component('bread-crumbs', () =>
  import('./components/header/BreadCrumbs.vue')
)
